import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconCircleSolid = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("circle", { cx: 12, cy: 12, r: 4 }) }));
const Memo = memo(SvgIconCircleSolid);
export default Memo;
//# sourceMappingURL=IconCircleSolid.js.map